import { useFormContext, useFieldArray } from 'react-hook-form';

import type { Option } from 'shared/models/common';

import { createBaseRenovationType } from '../helpers';
import type {
  FormState,
  RenovationTypeOption,
} from '../SpaceRenovationRequestCreateForm.type';

import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import RenovationType from './RenovationType';

type RenovationTypesProps = {
  descriptionsMaxLength: number;
  foreignRegistrationNumberMaxLength: number;
  organizationNameMaxLength: number;
  executorCodes: Option<number>[];
  renovationTypeOptions: RenovationTypeOption[];
};

const RenovationTypes = ({
  descriptionsMaxLength,
  foreignRegistrationNumberMaxLength,
  organizationNameMaxLength,
  executorCodes,
  renovationTypeOptions,
}: RenovationTypesProps) => {
  const { control } = useFormContext<FormState>();

  const { fields, append, remove } = useFieldArray({
    name: 'renovationTypes',
    control,
  });

  return (
    <Stack spacing={2.5}>
      {fields.map((field, idx) => (
        <RenovationType
          key={field.id}
          descriptionsMaxLength={descriptionsMaxLength}
          organizationNameMaxLength={organizationNameMaxLength}
          foreignRegistrationNumberMaxLength={
            foreignRegistrationNumberMaxLength
          }
          executorCodes={executorCodes}
          field={field}
          idx={idx}
          remove={remove}
          renovationTypeOptions={renovationTypeOptions}
          totalLength={fields.length}
        />
      ))}

      <Button
        onClick={() => append(createBaseRenovationType())}
        sx={{ alignSelf: 'flex-start' }}
      >
        LISÄÄ MUUTOSTYÖ
      </Button>
    </Stack>
  );
};

export default RenovationTypes;
